import { CanActivateFn } from "@angular/router";
import { inject } from "@angular/core";

import { AuthService } from "../api/auth.service";

export const LoggedInCookieGuard: CanActivateFn = () => {
  const authService = inject(AuthService);

  authService.setTokenFromCookie();
  return true;
};
